import { Component } from '@angular/core';
import { VideoPlayerComponent } from "../../../components/video-player/video-player.component";
import { comments, courses } from '../../../providers/static-data';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-course-view',
  standalone: true,
  imports: [VideoPlayerComponent,CommonModule],
  templateUrl: './course-view.component.html',
  styleUrl: './course-view.component.css'
})
export class CourseViewComponent {

  upcoming_video = courses
  comments = comments

}
